import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { usuarioService } from "../services/usuarioService";
import { UsuarioFilters } from "../types/usuario";
import { UsuarioFormData } from "../lib/validations";
import { useGlobalStore } from "../store/globalStore";
import { getErrorMessage } from "../utils/errorHandler";

export const useUsuarios = (
  filters?: UsuarioFilters,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: ["usuarios", filters],
    queryFn: () => usuarioService.getUsuarios(filters),
    enabled: options?.enabled ?? true,
  });
};

export const useCreateUsuario = () => {
  const queryClient = useQueryClient();
  const { setError } = useGlobalStore();

  return useMutation({
    mutationFn: (data: UsuarioFormData) => usuarioService.createUsuario(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["usuarios"] });
    },
    onError: (error) => setError(getErrorMessage(error)),
  });
};

export const useUpdateUsuario = () => {
  const queryClient = useQueryClient();
  const { setError } = useGlobalStore();

  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: UsuarioFormData }) =>
      usuarioService.updateUsuario(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["usuarios"] });
    },
    onError: (error) => setError(getErrorMessage(error)),
  });
};

export const useDeleteUsuario = () => {
  const queryClient = useQueryClient();
  const { setError } = useGlobalStore();

  return useMutation({
    mutationFn: (id: number) => usuarioService.deleteUsuario(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["usuarios"] });
    },
    onError: (error) => setError(getErrorMessage(error)),
  });
};
